import React from 'react';

import { useRecoilValue } from 'recoil';
import { selectedMenu } from 'state';
import styled from 'styled-components';

import {
  ContentBox,
  Contents,
} from '../../components';
import DashboardContents from "./Components/DashboardContents";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Dashboard = () => {
    const menu = useRecoilValue(selectedMenu);

    return (
        <Container>
            <ContentsWrap>
                <Wrap>
                    <ContentBox>
                        {/*<DashboardContents/>*/}
                    </ContentBox>
                </Wrap>
            </ContentsWrap>
        </Container>
    );
};
export default Dashboard;

const Container = styled.div``;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;
`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
`;
const BannerContents = styled.div`
    width: 1048px;
    height: 100%;
    position: absolute;
    z-index: 1;
    padding: 25px 20px;
    background: linear-gradient(269.04deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 0.75) 79.51%);
    h2 {
        text-transform: uppercase;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        opacity: 0.9;
        line-height: 35.28px;
    }
    p {
        opacity: 0.8;
        color: #fff;
        width: 470px;
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 30px;
    }
`;
const Create = styled.div`
    background: #ddc160;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
    img {
        width: 16px;
        height: 16px;
    }
`;
const CreateContents = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    span {
        line-height: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
    }
`;
